module.exports = __webpack_public_path__ + "res/dummy_quiz.80027401bd6099234cf389aeca9a623f.png";